import {
  RegisterCompanyPayload,
  MeUserResponse,
  LoginResponse,
  LoginPayload,
  PasswordResetPayload,
} from './useAuth.types';
import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';

export const useLoginAuth: BaseHookRequest<LoginResponse, LoginPayload> = params => {
  const [{ postRequest }, state] = useApi<LoginResponse>(params);
  const login: BaseRequest<LoginPayload> = details =>
    postRequest<LoginPayload>('/manager/auth/login', details?.variables);

  return [login, state];
};

export const usePasswordReset: BaseHookRequest<undefined, PasswordResetPayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const reset: BaseRequest<PasswordResetPayload> = details =>
    postRequest<PasswordResetPayload>('/manager/auth/passwordReset', details?.variables);

  return [reset, state];
};

export const useRegisterManagerWithCompany: BaseHookRequest<undefined, RegisterCompanyPayload> =
  params => {
    const [{ postRequest }, state] = useApi<undefined>(params);
    const registerUser: BaseRequest<RegisterCompanyPayload> = details =>
      postRequest<RegisterCompanyPayload>('/manager/auth/registerWithManager', details?.variables);
    return [registerUser, state];
  };

export const useMe: BaseHookRequest<MeUserResponse, null> = params => {
  const [{ getRequest }, state] = useApi<MeUserResponse>(params);
  const registerUser: BaseRequest<null> = () => getRequest<null>('/manager/auth/me');
  return [registerUser, state];
};
